/** @jsx jsx */
import { css } from '@emotion/react'

export const header = css`
  display: flex;
  justify-content: center;
  height: 86px;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 5;
  background: #3C5960;
  padding: 0;
  /* border-bottom: 2px solid rgba(255, 255, 255, 0.1); */
  .customContainer {
    display: flex;
    align-items: center;
    margin: 0;
    padding: 0;
    width: 100%;
    justify-content: center;
  }

  .customRow {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    align-content: center;
    flex-wrap: nowrap;
  }

  .col-nav {
    display: flex !important;
    align-items: center;
    padding: 0;
    justify-content: end;

    .arrow {
      border: solid #C2F57E;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 6px;
    height: 7px;
    margin-left: 12px;
    }
    .down {
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
  }


  }

  .col-btn {
    padding: 0 45px 0 0;
    display: flex;
    justify-content: end;
    display: none;

    @media (max-width: 768px) {
      padding-right: 15px;
      display: block;
      display: flex;
    }
  }

  .main-ul {
    display: flex;
    align-items: center;
    gap: 32px;
    justify-content: center;
  }

  .col-logo{
    /* padding: 0 0 0 45px; */
    @media (max-width: 768px) {
      padding-right: 0;
      padding-left: 15px;
    }
  }

  .menu {
    color:#efefef;
    @media (min-width: 767px) {
      display: none;
    }
  }

  &.fixedHeader {
    background-color: #efefef;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    width: 100%;
    z-index: 999;
    border: none;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
    -webkit-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
    -moz-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);

    img{
      display: none;
    }

    .dark{
      display: block;
    }

    .main-ul{
      li{
        i{
          border-color: #3B43FF !important;
        }
        a{
          color: #33535E !important;
        }
      }
    }

    .social-media-icons{
      a{
        i{
          color: #33535E;
          &:hover{
            color: #3B43FF;
          }
        }
      }
    }

    .menu{
      color: #33535E;
    }
  }

  &.black_color {
    border-color: #e5e5e5;

    &.fixedHeader {
      background-color: #ffffff;
    }

    nav ul li a {
      color: #000000;
      &:after {
        background-color: #000000;
      }
    }

    nav ul ul {
      background-color: #ffffff;
      &:before {
        border-bottom: 5px solid #fff;
      }
    }
  }

  @media (min-width: 320px) and (max-width: 767px) {
  }
`

export const logo = css`
  text-align: left;
  img {
    max-width: 100%;
    height: auto;
  }
  .dark{
    display: none;
  }
`
export const navLinksStyle = css`
  display: flex !important;
`
export const mainMenu = css`
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  position: relative;
  font-family: 'obviously-narrow';
  @media (max-width: 768px) {
    display: none;
  }
  ul {
    margin: 0;
    padding: 0;

    & li {
      list-style: none;
      display: inline-block;
      line-height: 0.8;
      position: relative;
      align-items: center;
      padding: 8px 0;

      & > .active a {
        color: #fff;
        :hover {
          color: #C2F57E;
        }
        &:after {
          width: 100%;
        }
      }

      & a {
        display: block;
        position: relative;
        color: #efefef !important;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        font-variation-settings: 'wght' 700;
        line-height: 120%; /* 24px */
        text-transform: uppercase;
        cursor: pointer;

        &:hover {
          color: #C2F57E !important;
          text-decoration: none;
          /* &:after {
            width: 100%;
            background-color: transparent;
          } */
        }

        &:after {
          position: absolute;
          width: 0;
          height: 1px;
          content: '';
          background: #fff;
          left: 0;
          right: 0;
          bottom: -5px;
          -moz-transition: all 0.4s ease-out;
          -webkit-transition: all 0.4s ease-out;
          transition: all 0.4s ease-out;
        }
      }

      &:hover .sub-menu {
        visibility: visible;
        opacity: 1;
        top: 40px;
      }
    }

    & ul.sub-menu {
      padding: 6px 16px;
      & li {
        margin: 0;
        padding: 0 0 2px;
        display: block;
        text-align: left;
        :not(:last-child) {
          border-bottom: 1px solid #312f2d;
          margin-bottom: 2px;
        }
        :last-child {
          padding-bottom: 6px;
        }
        & a {
          color: #312f2d !important;
          font-size: 18px;
          font-style: normal;
          font-weight: 700;
          line-height: 120%;
          text-transform: uppercase;
          display: block;
          padding: 6px 7px 9px;
          &:after {
            bottom: 0;
          }
          &:hover {
            color:#ffffff !important;
            background-color: #9312FF;
          }
        }
      }
    }
  }
`

export const submenu = css`
  /* background-color: ${(props) => (props.dark ? '#ffffff' : '#000000')}; */
  background-color: #C2F57E;
  width: 230px;
  z-index: 9;
  text-align: center;
  transition: all ease 400ms;
  -webkit-transition: all ease 400ms;
  -moz-transition: all ease 400ms;
  visibility: hidden;
  opacity: 0;
  left: 50%;
  margin: auto;
  position: absolute;
  right: 0;
  text-align: center;
  top: 100px;
  transform: translateX(-50%);
  z-index: 2;

  /* &:before {
    content: '';
    left: 0;
    margin: auto;
    position: absolute;
    right: 0;
    top: -5px;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid #000;
    z-index: 10;
  } */
`

export const navigator = css`
  display: flex;
  position: relative;
  padding: 0;

  .social-media-icons {
    margin-right: 16px;
    gap: 5px;
    display: flex;
    align-items: center;
    a{
      color: #efefef;
      margin-left: 16px;
      i{
        font-size: 20px;
      }
      &:hover{
        color: #C2F57E;
      }
    }

   

    @media (max-width: 768px) {
      margin-right: 0;
    }
  }

  & a {
    display: inline-block;
    color: #000;
    line-height: 0.8;
    font-size: 25px;
    margin: 0;

    &:hover,
    .active {
      color: #33535E;
    }

    &.search {
      margin-right: 16px;
    }
  }

  @media (min-width: 320px) and (max-width: 767px) {
    padding-top: 0;
    gap: 33px;
    margin-left: 33px;
    & a {
      &.search {
        margin-right: 10px;
      }
    }
  }
`

export const socialCol = css`
  @media (max-width: 768px) {
    display: none;
  }
  a {
    display: flex;
    gap: 4px;
    font-family: 'obviously-narrow';
    font-variation-settings: 'wght' 700;
    font-size: 16px !important;
    font-style: normal;
    font-weight: 700;
    line-height: 120% !important;
    letter-spacing: 0.8px;
    text-transform: uppercase;
    color: #312f2d !important;
    display: flex;
    align-items: center;
    border: 2px solid #312f2d;
    background: #C2F57E;
    padding: 8px !important;
    padding-top: 6px !important;
    text-align: center;
    cursor: pointer;
    transition: transform 2000ms ease, opacity 2000ms ease, color 500ms ease,
      background 500ms ease, -webkit-transform 2000ms ease;
    height: 40px;
    img {
      margin-left: 16px;
    }
    :hover {
      color: #C2F57E;
      text-decoration: none;
      img {
        filter: invert(80%) sepia(49%) saturate(718%) hue-rotate(35deg)
          brightness(105%) contrast(92%);
      }
    }
    :active {
      color: #33535E;
      img {
        filter: invert(27%) sepia(62%) saturate(4224%) hue-rotate(147deg)
          brightness(86%) contrast(94%);
      }
    }
  }
`
